import { createApp } from 'vue';
import { createWebHistory, createRouter, RouterView } from 'vue-router';
import { useActionRouteHandler } from './composables/useActionRouteHandler';
import { initializeFirebase, initializeProduct, useI18n } from 'ihunter-pathfinder-components';
import { Environment } from 'ihunter-common';

import LoginView from './views/LoginView.vue';
import HomeView from './views/HomeView.vue';
import ResetPasswordView from './views/ResetPasswordView.vue';
import AcceptInviteView from './views/AcceptInviteView.vue';
import PrivacyPolicyView from './views/PrivacyPolicyView.vue';
import EULAView from './views/EULAView.vue';

import environmentConfig from '../environment.config.json';
import firebaseConfig from '../firebase.config.json';

import 'ihunter-pathfinder/colors/ihunter.css'; // iHunter themed colors
import 'ihunter-pathfinder/styles/palette.css'; // Color palettes mapping
import 'ihunter-pathfinder/styles/base.scss'; // General styles & fonts

import en from '../locales/en.json';
import fr from '../locales/fr.json';
const { initializeI18n, processRouteLocale } = useI18n();

const { redirectFromActionRoute } = useActionRouteHandler();

console.log(`Starting iHunter Accounts`);
const env = new Environment(environmentConfig, {
    default: 'dev', // Set to 'local' to use emulator instead of dev servers
  //  firebase: 'localhost'
});
const config = env.config;

console.log(`Connecting to ${env.firebase}`);
const firebase = initializeFirebase(firebaseConfig[env.firebase]);

const i18n = initializeI18n({ en, fr });

const routes = [
    {
        path: '/:locale?',
        component: RouterView,
        beforeEnter: processRouteLocale,
        children: [
            { path: '', name: 'Home', component: HomeView},
            { path: 'login', name: 'Login', component: LoginView },
            { path: 'reset-password', name: 'ResetPassword', component: ResetPasswordView},
            { path: 'accept-invite', name: 'AcceptInvite', component: AcceptInviteView},
            { path: 'privacy', name: 'Privacy', component: PrivacyPolicyView },
            { path: 'eula', name: 'EULA', component: EULAView },
            { path: 'action', redirect: redirectFromActionRoute }
        ]
    }
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});

const SITE_TITLE = 'iHunter Account';
router.beforeEach((to, from, next) => {
    if (to.name) {
        const pageTitle = to.name.replace(/([a-z])([A-Z])/g, '$1 $2');
        document.title = `${SITE_TITLE} - ${pageTitle}`;
    }
    next();
  });

console.log(`Starting user interface`);
const vueApp = createApp(RouterView);
vueApp.use(router);
vueApp.use(i18n);

router.isReady().then(() => {
    console.log(`Router initialized`);
    initializeProduct(config, router.currentRoute);
    vueApp.mount('#app');
});
